import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { ClientErrorReportsPage } from '../../../models/ClientErrors/ClientErrorReportsPage';

export const fetchClientErrorReports = createAsyncThunk(
    'clientErrors/fetchClientErrorReports',
    async (params: { page: number; pageSize: number; isResolved: boolean }, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.get(
            `/api/ClientErrorReports?page=${params.page}&pageSize=${params.pageSize}&isResolved=${params.isResolved}`
        );

        if (response.status !== 200) {
            createNotification('Could not fetch client error reports at the moment.', 'error');
            throw new Error('Failed to fetch client error reports');
        }

        return response.data as ClientErrorReportsPage;
    }
);
